export const SUPPORT_SETTINGS_SECTOR_ALIAS = Object.freeze({
  ACADEMIC     : 'academic',
  DOCUMENTS    : 'documents',
  FINANCIAL    : 'financial',
  HOME         : 'home',
  REENROLLMENT : 'reenrollment',
  SERVICES     : 'services',
  SUBJECTS     : 'subjects',
  CONTENTS     : 'contents'
});
